"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Example_vue_1 = __importDefault(require("./Example.vue")); // @ts-ignore


var app = window.Vue.createApp(Example_vue_1.default);
app.mount('#app');